import React, {useEffect, useState} from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Cookies from 'js-cookie';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import {Button, useMediaQuery} from '@mui/material';

// ICON LIST
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import macWP from '../../assets/images/macWP.jpg';
import {light} from '@mui/material/styles/createPalette';
import axios from 'axios';
import {SearchKawasan} from '../../components/SearchKawasan';
import {Loader} from '../../components/Loader';
import {Language} from '../../context/LanguageContext';
import {Link, useNavigate, useSearchParams} from 'react-router-dom';
import {LocalizationProvider, MobileDatePicker} from '@mui/x-date-pickers';
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment';
import {IconDownload} from '../../assets';
import {CheckBoxLaporanKerja} from '../../components';
import moment from 'moment';
import {formatQueryString} from '../../utils';

const LaporanKerja = () => {
  const {language, newObj} = Language();
  const [doc, setDoc] = useState([]);
  const [wilayahKod, setWilayahKod] = useState('');
  const [negeriKod, setNegeriKod] = useState('');
  const [projectCode, setProjectCode] = useState('');
  const [PKCode, setPKCode] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoad, setLoad] = useState(true);
  const [count, setCount] = useState(0);
  const [selectedWilayah, setSelectedWilayah] = useState(['All Wilayah']);
  const [wilayahObj, setWilayahObject] = useState([]);
  const [deleteCount, setDeleteCount] = useState(0);
  const [isSearch, setSearch] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const today = moment().format('YYYY/MM/DD');
  const date30DaysAgo = moment(today, 'YYYY/MM/DD')
    .subtract(30, 'days')
    .format('YYYY/MM/DD');
  const [startDate, setStartDate] = useState(date30DaysAgo);
  const [endDate, setEndDate] = useState(today);
  const tokens_session = Cookies.get('token');
  const apiUrl = process.env.REACT_APP_MAIN_URL;
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [flagDM, setFlagDM] = useState(true);
  const theme = createTheme({
    typography: {
      fontFamily: ['Montserrat'].join(','),
    },
  });

  // data and function for searchKawasan
  const displayIndex = count > 3 ? 3 : count;

  const emptyObject = () => {
    if (isSearch) getWilayahObject();
    setCount(0);
    setSelectedWilayah(['All Wilayah']);
    setWilayahKod('');
    setPKCode('');
    setProjectCode('');
    setSearchParams();
  };

  const returnClick = (index) => {
    const params = {};

    for (let [key, value] of searchParams.entries()) {
      params[key] = value;
    }
    if (index + 1 === 1) {
      delete params.kodWilayah;
      delete params.kodProjek;
      delete params.kodKawasan;
      setPKCode('');
      setProjectCode('');
      setSearchParams(params);
    } else if (index + 1 === 2) {
      delete params.kodProjek;
      delete params.kodKawasan;
      setPKCode('');
      setProjectCode('');
      setSearchParams(params);
    } else {
      delete params.kodProjek;
      setProjectCode('');
      setSearchParams(params);
    }
    setSelectedWilayah(selectedWilayah.slice(0, index + 2));
    setCount(index + 1);
  };

  const backClick = () => {
    const returnFlag = count > 3 ? 3 : count;
    const params = {};

    for (let [key, value] of searchParams.entries()) {
      params[key] = value;
    }
    if (returnFlag === 1) {
      delete params.kodWilayah;
      setSearchParams(params);
    } else if (count === 2) {
      delete params.kodKawasan;
      setSearchParams(params);
    } else {
      delete params.kodProjek;
      setSearchParams(params);
    }
    setWilayahObject([]);
    setSelectedWilayah(selectedWilayah.slice(0, returnFlag));
    setCount(returnFlag - 1);
  };

  const detailArea = async (flag, code) => {
    setLoad(true);
    try {
      const res = await axios.post(
        `${apiUrl}/area/detail-area`,
        {flag: flag, code: code},
        {
          headers: {
            Authorization: `Bearer ${tokens_session}`,
            'Content-Type': 'multipart/form-data',
          },
        },
      );

      if (res.data.status === 200) {
        return res.data.data;
      }
      if (res.data.status === 401) {
        Cookies.remove('token');
        navigate('/login');
      }
      return res.data;
    } catch (error) {
      throw error;
    }
  };

  function handleSearch(event) {
    setSearchTerm(event);
    searchArea(event);
  }

  const searchArea = async (word) => {
    setLoad(true);
    try {
      const res = await axios.post(
        `${apiUrl}/task-report/search-area`,
        {keyword: word},
        {
          headers: {
            Authorization: `Bearer ${tokens_session}`,
            'Content-Type': 'multipart/form-data',
          },
        },
      );

      setLoad(false);
      if (res.data.status === 200) {
        console.log(res?.data?.data);
        setSelectedWilayah(['All Wilayah']);
        setWilayahKod('all');
        setPKCode('all');
        setCount(0);
        setProjectCode('all');
        setSearch(true);
        setWilayahObject(res?.data?.data);
      }
      if (res.data.status === 401) {
        Cookies.remove('token');
        // destroyCookie(null, 'token');
        navigate('/login');
      }
      return res.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const onWilayahClick = async (e, id, flag, item) => {
    const objFlag = ['', 'negeri', 'pk', 'project'];
    const index = objFlag.indexOf(flag);
    let obj = e.target.textContent + '$' + id;
    if (isSearch) {
      let returnData = '';
      if (index !== -1) {
        returnData = await detailArea(flag, id);
        const tempSearchParams = {};
        const reversedData = returnData.reverse().map((obj, i) => {
          if (i === 0) tempSearchParams['idWilayah'] = obj?.code;
          else if (i === 1) {
            setWilayahKod(obj?.code);
            tempSearchParams['kodWilayah'] = obj?.code;
          } else if (i === 2) {
            setPKCode(obj?.code);
            tempSearchParams['kodKawasan'] = obj?.code;
          }
          if (obj.code === null) {
            return `${obj.name}$${obj.id}`;
          } else {
            return `${obj.name}$${obj.code}`;
          }
        });
        if (returnData.length === 1) {
          setWilayahKod(id);
          tempSearchParams['kodWilayah'] = id;
        } else if (returnData.length === 2) {
          setPKCode(id);
          tempSearchParams['kodKawasan'] = id;
        } else if (returnData.length === 3) {
          setProjectCode(id);
          tempSearchParams['kodProjek'] = id;
        }
        setSearchParams(tempSearchParams);
        setSelectedWilayah(['All Wilayah', ...reversedData, obj]);
        setCount(index + 1);
      } else {
        setCount(1);
        setSelectedWilayah(['All Wilayah', obj]);
      }
      setSearchTerm();
      setSearch(false);
    } else {
      if (selectedWilayah.length < 5) {
        const params = {};
        for (let [key, value] of searchParams.entries()) {
          params[key] = value;
        }
        let name = item.title;
        if (count === 0) {
          name = item.wilayah;
          setSearchParams({...params, idWilayah: id});
          setWilayahKod(id);
        } else if (count === 1) {
          name = item.negeri;
          setSearchParams({...params, kodWilayah: id});
          setNegeriKod(id);
        } else if (count === 2) {
          name = item.pkName;
          setSearchParams({...params, kodKawasan: id});
          setPKCode(id);
        } else {
          name = item.namaProjek;
          setSearchParams({...params, kodProjek: id});
          setProjectCode(id);
        }
        let obj = name + '$' + id;
        setSelectedWilayah([...selectedWilayah, obj]);

        setCount(count + 1);
      } else if (selectedWilayah.length === 5) {
        const params = {};
        for (let [key, value] of searchParams.entries()) {
          params[key] = value;
        }
        setProjectCode(id);
        setSearchParams(params);
        setSelectedWilayah([
          ...selectedWilayah.slice(0, selectedWilayah.length - 1),
          obj,
        ]);
      }
    }
    setFlagDM(false);
  };

  const getWilayahObject = async () => {
    try {
      const res = await axios.get(`${apiUrl}/lintramax/get-lintramax-wilayah`, {
        headers: {
          Authorization: `Bearer ${tokens_session}`,
        },
      });
      setLoad(false);
      if (res.data.status === 200) {
        setWilayahObject(res?.data?.data);
      }
      if (res.data.status === 401) {
        Cookies.remove('token');
        // destroyCookie(null, 'token');
        navigate('/login');
      }
      return res.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const getNegeriByWilayah = async (id) => {
    try {
      const res = await axios.post(
        `${apiUrl}/lintramax/get-lintramax-negeri-by-wilayah`,
        {code: id},
        {
          headers: {
            Authorization: `Bearer ${tokens_session}`,
            'Content-Type': 'multipart/form-data',
          },
        },
      );
      setLoad(false);
      if (res.data.status === 200) {
        setWilayahObject(res?.data?.data);
      }
      if (res.data.status === 401) {
        Cookies.remove('token');
        // destroyCookie(null, 'token');
        navigate('/login');
      }
      return res.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const getDataPKCodeByNegeri = async (id) => {
    try {
      const res = await axios.post(
        `${apiUrl}/lintramax/pk-code/get-data-by-negeri`,
        {kod_negeri: id},
        {
          headers: {
            Authorization: `Bearer ${tokens_session}`,
            'Content-Type': 'multipart/form-data',
          },
        },
      );
      setLoad(false);
      if (res.data.status === 200) {
        setWilayahObject(res?.data?.data);
      }
      if (res.data.status === 401) {
        Cookies.remove('token');
        // destroyCookie(null, 'token');
        navigate('/login');
      }
      return res.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const getDataProjectCodeByPKCode = async (id) => {
    const formData = new FormData();

    formData.append('pk_code', id);
    try {
      const res = await axios.post(
        `${apiUrl}/lintramax/projek-kod/get-data`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${tokens_session}`,
            'Content-Type': 'multipart/form-data',
          },
        },
      );

      setLoad(false);
      if (res.data.status === 200) {
        setWilayahObject(res?.data?.data);
      }
      if (res.data.status === 401) {
        Cookies.remove('token');
        // destroyCookie(null, 'token');
        navigate('/login');
      }
      return res.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const getDoc = async (
    kod_wilayah,
    kode_negeri,
    pk_code,
    project_code,
    start_date,
    end_date,
  ) => {
    try {
      const formattedProjectCode = project_code.toLowerCase().startsWith('f')
        ? project_code.slice(1)
        : project_code;
      const res = await axios.post(
        `${apiUrl}/task-report/get`,
        {
          start_date,
          end_date,
          kod_wilayah: kod_wilayah,
          kod_negeri: kode_negeri,
          pk_code: pk_code,
          kod_projek: formattedProjectCode,
        },
        {
          headers: {
            Authorization: `Bearer ${tokens_session}`,
            'Content-Type': 'multipart/form-data',
          },
        },
      );
      if (res.data.status === 200) {
        setDoc(res?.data?.data);
      } else if (res.data.status === 500) {
        setDoc([]);
      }
      if (res.data.status === 401) {
        Cookies.remove('token');
        navigate('/login');
      }
      setLoad(false);
      return res.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const handleDownload = async (payload) => {
    try {
      const response = await axios.get(
        `${apiUrl}/task-report/download${formatQueryString(payload)}`,
        {
          headers: {
            Authorization: `Bearer ${tokens_session}`,
            'Content-Type': 'multipart/form-data',
          },
          responseType: 'arraybuffer',
        },
      );
      if (response.status === 200) {
        const filename = response.headers['content-disposition'];
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', filename?.split('=')[1]);
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (count === 0 && !isSearch) {
      getDoc('all', 'all', 'all', 'all', startDate, endDate);
      getWilayahObject();
      setWilayahKod('all');
      setNegeriKod('all');
      setPKCode('all');
      setProjectCode('all');
    } else {
      const id = selectedWilayah[count].split('$')[1];
      if (count === 1) {
        getNegeriByWilayah(id);
        setWilayahKod(id);
        setPKCode('all');
        setProjectCode('all');
      } else if (count === 2) {
        setNegeriKod(id);
        getDataPKCodeByNegeri(id);
      } else if (count === 3) {
        getDataProjectCodeByPKCode(id);
        setPKCode(id);
      } else if (count >= 4) {
        setProjectCode(id);
      }
    }
  }, [count]);

  useEffect(() => {
    if (
      searchParams.getAll('idWilayah')[0] &&
      searchParams.getAll('kodWilayah')[0] &&
      searchParams.getAll('kodKawasan')[0] &&
      searchParams.getAll('kodProjek')[0] &&
      flagDM === true
    ) {
      const fetchData = async () => {
        const res1 = await getWilayahObject();
        const res2 = await getNegeriByWilayah(
          searchParams.getAll('idWilayah')[0],
        );
        const res3 = await getDataPKCodeByNegeri(
          searchParams.getAll('kodWilayah')[0],
        );
        const res4 = await getDataProjectCodeByPKCode(
          searchParams.getAll('kodKawasan')[0],
        );
        const found1 = res1?.data?.find(
          (el) => el.id === searchParams.getAll('idWilayah')[0],
        );
        const found2 = res2?.data.find(
          (el) => el.code === searchParams.getAll('kodWilayah')[0],
        );
        const found3 = res3?.data.find(
          (el) => el.code === searchParams.getAll('kodKawasan')[0],
        );
        const found4 = res4?.data.find(
          (el) => el.code === searchParams.getAll('kodProjek')[0],
        );
        setSelectedWilayah([
          ...selectedWilayah,
          `${found1?.wilayah}$${found1?.id}`,
          `${found2?.negeri}$${found2?.code}`,
          `${found3?.title}$${found3?.code}`,
          `${found4?.title}$${found4?.code}`,
        ]);
        setCount(4);
        setWilayahKod(found1?.code);
        setNegeriKod(found2?.code);
        setPKCode(found3?.code);
        setProjectCode(found4?.code);
        setWilayahObject(res4?.data);
      };
      fetchData();
    }
  }, [
    searchParams.getAll('idWilayah')[0],
    searchParams.getAll('kodWilayah')[0],
    searchParams.getAll('kodKawasan')[0],
    searchParams.getAll('kodProjek')[0],
  ]);

  useEffect(() => {
    const w = wilayahKod ? wilayahKod : 'all';
    const n = negeriKod ? negeriKod : 'all';
    const pk = PKCode ? PKCode : 'all';
    const project = projectCode ? projectCode : 'all';
    getDoc(w, n, pk, project, startDate, endDate);
  }, [PKCode, projectCode, wilayahKod, negeriKod, startDate, endDate]);

  useEffect(() => {
    getDoc('all', 'all', 'all', 'all', startDate, endDate);
  }, [deleteCount]);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const data = [
    {
      title: 'Lokasi',
      name: selectedWilayah[displayIndex]?.split('$')[0],
    },
    {title: 'PK Kod', name: PKCode},
    {title: 'Projek Kod', name: projectCode},
  ];

  const isXsScreen = useMediaQuery(theme.breakpoints.between('xs', 'sm'));
  const isSmScreen = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  return (
    <div>
      {isLoad && (
        <div style={{position: 'absolute'}}>
          <Loader />
        </div>
      )}
      <ThemeProvider theme={theme}>
        {' '}
        <Box
          style={{
            backgroundImage: `url(${macWP})`,
            backgroundRepeat: 'no-repeat',
            backgroundColor: (t) =>
              t.palette.mode === 'light'
                ? t.palette.grey[50]
                : t.palette.grey[900],
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            display: 'flex',
            justifyContent: 'center',
            padding: isXsScreen || isSmScreen ? '10px' : '20px 10px',
          }}
        >
          {/* nav */}
          <Box className='headerWithButton'>
            <Box display='flex'>
              <Link
                to='/adminpage'
                style={{
                  textDecoration: 'none',
                  alignItems: 'center',
                  display: 'flex',
                  padding: '8px 16px',
                }}
              >
                <ChevronLeftIcon sx={{fontSize: '28px', color: '#2B337D'}} />
                <Box
                  sx={{
                    color: '#2B337D',
                    display: 'flex',
                    alignItems: 'center',
                    margin: '0 !important',
                    fontWeight: 'bold !important',
                  }}
                  fontWeight='bold'
                  p={0}
                  ml={3}
                  mb={0}
                >
                  Laporan
                </Box>
              </Link>
            </Box>
          </Box>

          <Grid
            container
            columnSpacing={{xs: 1, sm: 2, md: 1}}
            style={{
              minHeight: 'calc(100vh - 120px)',
              display: 'flex',
              marginTop: '60px',
              justifyContent: 'center',
            }}
          >
            <Grid item md={3} xs={12} style={{position: 'relative'}}>
              <SearchKawasan
                count={count}
                filteredArray={wilayahObj}
                displayIndex={displayIndex}
                selectedWilayah={selectedWilayah}
                returnClick={returnClick}
                onWilayahClick={onWilayahClick}
                handleSearch={handleSearch}
                backClick={backClick}
                emptyObject={emptyObject}
                windowWidth={windowWidth}
                isLintra={false}
              />
            </Grid>
            <Grid item md={9} xs={12} sx={{}}>
              <Box
                sx={{
                  backgroundColor: 'rgba(255,255,255,0.8)',
                  borderRadius: '5px',
                  minHeight: '100vh',
                }}
              >
                <Box
                  sx={{
                    padding: '15px',
                    borderBottom: '1px solid gray',
                    display: 'flex',
                    gap: '20px',
                  }}
                >
                  {/* date */}
                  <div
                    style={{
                      padding: '0px 15px 0px 15px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                      color: 'white',
                      ...(windowWidth > 1000
                        ? {width: '40%'}
                        : {width: '100%'}),
                    }}
                  >
                    <CalendarMonthIcon htmlColor='#000' />

                    <div
                      style={{
                        display: 'flex',
                        ...(windowWidth >= 1000
                          ? {justifyContent: 'space-between'}
                          : {justifyContent: 'start'}),
                        alignItems: 'center',
                        width: '100%',
                      }}
                    >
                      <LocalizationProvider
                        dateAdapter={AdapterMoment}
                        sx={{border: '1px solid white'}}
                      >
                        <MobileDatePicker
                          autoFocus='true'
                          label='Start Date'
                          views={['day', 'month', 'year']}
                          onClose={() => {}}
                          onAccept={(date) => {
                            setStartDate(date.format('YYYY/MM/DD'));
                          }}
                          value={moment(startDate, 'YYYY/MM/DD')}
                          // minDate={moment(startBottomDate, 'YYYY/MM/DD')}
                          // maxDate={moment(endBottomDate, 'YYYY/MM/DD')}
                          format={'DD MMM YYYY'}
                        />
                      </LocalizationProvider>
                      <span
                        style={{
                          margin: '0 5px',
                          color: '#000',
                          fontWeight: '600',
                        }}
                      >
                        -
                      </span>
                      <LocalizationProvider
                        dateAdapter={AdapterMoment}
                        sx={{border: '1px solid white'}}
                      >
                        <MobileDatePicker
                          autoFocus='true'
                          label='End Date'
                          views={['day', 'month', 'year']}
                          onClose={() => {}}
                          onAccept={(date) => {
                            setEndDate(date.format('YYYY/MM/DD'));
                          }}
                          value={moment(endDate, 'YYYY/MM/DD')}
                          // minDate={moment(startBottomDate, 'YYYY/MM/DD')}
                          // maxDate={moment(endBottomDate, 'YYYY/MM/DD')}
                          format={'DD MMM YYYY'}
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      gap: '20px',
                    }}
                  >
                    {data.map((item, index) => (
                      <div key={index}>
                        <Box
                          sx={{
                            color: 'gray',
                            display: 'flex',
                            fontSize: '10px',
                            fontStyle: light,
                          }}
                        >
                          {item.title}
                        </Box>

                        <Box
                          sx={{
                            color: 'black',
                            display: 'flex',
                            fontSize: '15px',
                            fontWeight: 'normal !important',
                            alignItems: 'center',
                          }}
                        >
                          {item.name !== '' || item.name ? item.name : 'All'}
                        </Box>
                      </div>
                    ))}
                  </div>
                  <Button
                    style={{
                      marginLeft: 'auto',
                    }}
                    startIcon={<img src={IconDownload} alt='icon_download' />}
                    onClick={() =>
                      handleDownload({
                        kod_wilayah: wilayahKod,
                        kod_negeri: negeriKod,
                        pk_code: PKCode,
                        kod_projek:
                          projectCode[0] === 'F'
                            ? projectCode.slice(1)
                            : projectCode,
                        start_date: startDate,
                        end_date: endDate,
                      })
                    }
                  >
                    {newObj.DownloadWord[language]}
                  </Button>
                </Box>

                <Box
                  sx={{
                    padding: '15px',
                  }}
                >
                  <CheckBoxLaporanKerja
                    data={doc}
                    onSelectionChange={(option) => {}}
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </ThemeProvider>
    </div>
  );
};

export default LaporanKerja;
